import AssignUserModal from './AssignUserModal';

export default AssignUserModal;
